import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinmumbai() {



    const cardData = {




keyword: "Swift Dzire on Rent in Mumbai",

headingDescription: "Shreesha Tours & Travels offers affordable and reliable Swift Dzire on Rent in Mumbai for local travel, airport transfers, outstation trips, corporate travel, business meetings, family vacations, railway station transfers, sightseeing tours, and one-way or round-trip journeys. The Maruti Suzuki Swift Dzire is one of the most preferred sedan cars for its comfortable seating, spacious interiors, excellent mileage, smooth ride quality, and ample luggage space, making it an ideal choice for solo travelers, couples, families, and business executives. We provide chauffeur-driven Swift Dzire rental services with professional drivers, well-maintained vehicles, doorstep pickup, transparent pricing, flexible booking options, and 24/7 customer support. Whether you are planning a weekend getaway, a pilgrimage tour, a corporate trip, or a long-distance outstation journey from Mumbai, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free travel experience with premium service and punctual transportation.",

topPlaces: [
  {
    title: "Mumbai to Pune",
    description: "Pune is one of the most popular routes for Swift Dzire rentals from Mumbai. Business travelers, students, and families frequently choose this comfortable sedan for smooth travel to Hinjawadi, Baner, Kharadi, Magarpatta, Wakad, and other parts of Pune."
  },
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a favorite weekend destination known for Tiger Point, Bhushi Dam, Rajmachi Fort, waterfalls, and scenic valleys. Swift Dzire is an ideal car for couples and small families planning a relaxing hill station trip."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is famous for Venna Lake, Mapro Garden, Arthur's Seat, strawberry farms, and breathtaking viewpoints. Renting a Swift Dzire provides a comfortable and economical option for exploring this beautiful hill station."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, attracting devotees from across the country. Swift Dzire rental is a preferred choice for families visiting the sacred Sai Baba Temple."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is well known for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and religious attractions. A Swift Dzire offers comfortable travel for pilgrimage tours, wine tourism, and family outings."
  },
  {
    title: "Mumbai to Goa",
    description: "Goa is India's most famous beach destination, offering sandy beaches, churches, forts, nightlife, and water sports. Swift Dzire rentals are ideal for small families and groups planning an enjoyable road trip."
  },
  {
    title: "Mumbai to Alibaug",
    description: "Alibaug is a beautiful coastal destination featuring beaches, resorts, forts, and scenic seaside views. It is one of the most booked weekend routes for Swift Dzire rentals from Mumbai."
  },
  {
    title: "Mumbai to Surat",
    description: "Surat is a leading business city famous for its diamond and textile industries. Corporate travelers frequently rent Swift Dzire cabs for comfortable intercity business travel."
  },
  {
    title: "Mumbai to Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial and cultural hub with business centers, heritage sites, and industrial areas. Swift Dzire rentals provide economical and comfortable transportation for business and leisure travelers."
  },
  {
    title: "Mumbai to Kolhapur",
    description: "Kolhapur is famous for the Mahalakshmi Temple, Panhala Fort, Rankala Lake, and rich Maratha heritage. Swift Dzire rental is an excellent choice for family vacations, religious tours, and long-distance travel from Mumbai."
  }
],



"services": [
  {
    "name": "Swift Dzire on Rent in Mumbai",
    "description": "Book Swift Dzire on Rent in Mumbai for comfortable, affordable, and chauffeur-driven travel across the city and outstation destinations. The Swift Dzire is ideal for airport transfers, business meetings, family travel, sightseeing, railway station pickups, hotel transfers, and one way or round trip journeys. Enjoy clean AC vehicles, professional drivers, transparent pricing, doorstep pickup, and reliable service with flexible rental packages."
  },
  {
    "name": "Mumbai Swift Dzire Rental",
    "description": "Choose Mumbai Swift Dzire Rental for reliable and economical transportation with experienced chauffeurs and well-maintained AC sedan cars. Perfect for local travel, airport pickup and drop, corporate transportation, wedding functions, family outings, and long-distance travel. Enjoy comfortable seating, ample luggage space, flexible booking options, and affordable rental plans."
  },
  {
    "name": "Swift Dzire Cab Mumbai",
    "description": "Hire Swift Dzire Cab Mumbai for safe and comfortable travel with professional drivers and premium customer service. Our Swift Dzire cabs are suitable for local rides, airport transfers, office commuting, hotel pickups, sightseeing tours, business travel, and outstation trips with one way and round trip booking facilities available throughout Mumbai."
  },
  {
    "name": "Swift Dzire Car Rental Mumbai",
    "description": "Book Swift Dzire Car Rental Mumbai for chauffeur-driven travel with clean interiors, comfortable seating, and affordable pricing. Whether you are planning a family vacation, business tour, airport transfer, corporate event, or city sightseeing, our Swift Dzire rental service offers dependable transportation with flexible hourly, daily, and outstation rental packages."
  },
  {
    "name": "Swift Dzire Taxi Service Mumbai",
    "description": "Choose Swift Dzire Taxi Service Mumbai for reliable local and outstation transportation with experienced chauffeurs and well-maintained sedan vehicles. Enjoy smooth rides for airport transfers, office travel, business meetings, family functions, shopping trips, railway station pickups, and holiday travel with transparent fares and easy online booking."
  },
  {
    "name": "Swift Dzire Hire Mumbai",
    "description": "Reserve Swift Dzire Hire Mumbai for convenient chauffeur-driven travel with affordable pricing and premium comfort. Our Swift Dzire cars are perfect for daily commuting, airport transfers, corporate travel, personal visits, sightseeing tours, and long-distance journeys with flexible pickup and drop locations across Mumbai."
  },
  {
    "name": "Swift Dzire with Driver Mumbai",
    "description": "Book Swift Dzire with Driver Mumbai for stress-free travel with trained chauffeurs, clean AC vehicles, and professional service. Ideal for business executives, tourists, families, airport transfers, weddings, hotel transportation, and outstation travel with safe driving, punctual pickups, and customized travel schedules."
  },
  {
    "name": "Mumbai Sedan Car Rental",
    "description": "Choose Mumbai Sedan Car Rental for comfortable and affordable transportation with premium sedan vehicles including Swift Dzire. Enjoy chauffeur-driven services for airport transfers, city travel, corporate transportation, family vacations, sightseeing tours, railway station transfers, and outstation journeys with flexible rental plans and competitive pricing."
  },
  {
    "name": "Swift Dzire Outstation Cab Mumbai",
    "description": "Hire Swift Dzire Outstation Cab Mumbai for safe and comfortable long-distance travel from Mumbai to destinations across Maharashtra, Goa, Gujarat, Karnataka, and other nearby states. Enjoy one way and round trip packages with experienced drivers, clean AC cars, affordable fares, and convenient doorstep pickup for family, business, and leisure travel."
  },
  {
    "name": "Swift Dzire Airport Taxi Mumbai",
    "description": "Book Swift Dzire Airport Taxi Mumbai for timely airport pickup and drop services with professional chauffeurs and comfortable AC sedan cars. Benefit from flight tracking, punctual service, luggage assistance, doorstep pickup, and affordable airport transfer packages for domestic and international travelers."
  },
  {
    "name": "Swift Dzire Corporate Rental Mumbai",
    "description": "Choose Swift Dzire Corporate Rental Mumbai for reliable executive transportation, employee travel, client meetings, airport transfers, and office commuting. Our chauffeur-driven Swift Dzire fleet offers punctual service, monthly corporate rental packages, transparent billing, and comfortable travel solutions designed for businesses and corporate professionals."
  }
],
"tableData": [
  ["Swift Dzire on Rent in Mumbai", "Mumbai Swift Dzire Rental"],
  ["Swift Dzire Cab Mumbai", "Swift Dzire Car Rental Mumbai"],
  ["Swift Dzire Taxi Service Mumbai", "Swift Dzire Hire Mumbai"],
  ["Swift Dzire with Driver Mumbai", "Mumbai Sedan Car Rental"],
  ["Swift Dzire Outstation Cab Mumbai", "Swift Dzire Airport Taxi Mumbai"],
  ["Swift Dzire Corporate Rental Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Affordable Swift Dzire on Rent in Mumbai",
    WhyChoosedescription: "Travel comfortably with Shreesha Tours & Travels by booking a Swift Dzire on rent in Mumbai. Our well-maintained sedan is perfect for airport transfers, local city travel, business meetings, sightseeing tours, family outings, and outstation journeys."
  },
  {
    WhyChooseheading: "Comfortable Sedan for Every Travel Plan",
    WhyChoosedescription: "The Swift Dzire offers spacious seating, air-conditioned interiors, smooth performance, and ample luggage space, making it an excellent choice for solo travellers, couples, families, and corporate executives."
  },
  {
    WhyChooseheading: "Suitable for Local & Outstation Travel",
    WhyChoosedescription: "Hire a Swift Dzire for Mumbai city rides, airport pickups and drops, one-way trips, round trips, weekend getaways, pilgrimage tours, and long-distance travel across Maharashtra, Goa, Gujarat, Karnataka, and nearby states."
  },
  {
    WhyChooseheading: "Ideal for Corporate & Business Transportation",
    WhyChoosedescription: "Business professionals can rely on our Swift Dzire rental service for office travel, executive meetings, client visits, conferences, hotel transfers, and airport transportation with punctual service."
  },
  {
    WhyChooseheading: "Professional Drivers & Hassle-Free Travel",
    WhyChoosedescription: "Our experienced chauffeurs are courteous, knowledgeable about Mumbai routes and highways, and committed to providing a safe, smooth, and pleasant travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Packages",
    WhyChoosedescription: "Choose from hourly rentals, full-day packages, one-way taxi services, round-trip bookings, airport transfers, or customized travel plans based on your itinerary."
  },
  {
    WhyChooseheading: "Clean, Sanitized & Well-Maintained Swift Dzire",
    WhyChoosedescription: "Every Swift Dzire is regularly serviced, thoroughly cleaned, and inspected to ensure maximum comfort, safety, and reliability for every journey."
  },
  {
    WhyChooseheading: "Book Your Swift Dzire with Shreesha Tours & Travels",
    WhyChoosedescription: "Enjoy competitive pricing, quick booking confirmation, transparent fares, and dependable customer support whenever you need a Swift Dzire on rent in Mumbai."
  }
]

};

const faqData = [
  {
    question: "Why should I choose a Swift Dzire on rent in Mumbai?",
    answer: "The Swift Dzire is a comfortable, fuel-efficient sedan that's ideal for local travel, airport transfers, business trips, sightseeing, and outstation journeys."
  },
  {
    question: "Can I rent a Swift Dzire for outstation travel?",
    answer: "Yes, Swift Dzire taxis are available for one-way and round-trip travel to destinations across Maharashtra and other Indian states."
  },
  {
    question: "Is the Swift Dzire suitable for airport transfers?",
    answer: "Yes, the Swift Dzire is a popular choice for Mumbai Airport pickups and drops, offering comfortable seating and luggage space."
  },
  {
    question: "Can I book a Swift Dzire for corporate travel?",
    answer: "Yes, our Swift Dzire rental service is widely used for executive travel, business meetings, conferences, and office transportation."
  },
  {
    question: "Are hourly and full-day rental packages available?",
    answer: "Yes, you can choose hourly rentals, full-day bookings, one-way trips, round trips, or customized travel packages."
  },
  {
    question: "Does the rental include a professional driver?",
    answer: "Yes, all Swift Dzire rentals from Shreesha Tours & Travels include experienced and courteous chauffeurs."
  },
  {
    question: "Can I book a Swift Dzire for family trips and sightseeing?",
    answer: "Yes, the Swift Dzire is an excellent option for couples, families, tourists, and small groups exploring Mumbai or nearby destinations."
  },
  {
    question: "How is the Swift Dzire rental fare calculated?",
    answer: "The fare depends on the travel distance, rental duration, trip type, route, and any additional travel requirements."
  },
  {
    question: "Can I reserve a Swift Dzire in advance?",
    answer: "Yes, advance booking is recommended to ensure availability on your preferred travel date and time."
  },
  {
    question: "How can I book a Swift Dzire on Rent in Mumbai with Shreesha Tours & Travels?",
    answer: "Share your pickup location, destination, travel date, rental duration, and passenger details to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Shah",
    feedback: "I booked a Swift Dzire from Shreesha Tours & Travels for a business trip in Mumbai. The car was clean, the driver was punctual, and the ride was extremely comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Joshi",
    feedback: "Our family hired a Swift Dzire for an airport transfer and local sightseeing. The booking process was easy, the vehicle was well-maintained, and the overall service was excellent.",
    rating: 5
  }
];















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/swift-dzire-on-rent-in-mumbai.webp",
  "description":
    "Book Swift Dzire on Rent in Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable chauffeur-driven car rental services. We provide well-maintained Swift Dzire cabs available 24x7 for local travel, airport transfers, corporate travel, outstation trips, business meetings, family tours, and one-way or round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/swift-dzire-on-rent-in-mumbai"
  }
};





    return (
        <div>


<Helmet>
  <title>Swift Dzire on Rent in Mumbai | Sedan Cab Rental | +91 8355835813</title>

  <meta
    name="description"
    content="Book Swift Dzire on Rent in Mumbai with Shreesha Travels for reliable local, airport, and outstation taxi services. Hire chauffeur-driven Swift Dzire sedans at affordable rates with 24x7 online booking."
  />

  <meta
    name="keywords"
    content="Swift Dzire on Rent in Mumbai, Mumbai Swift Dzire Rental, Swift Dzire Cab Mumbai, Swift Dzire Car Rental Mumbai, Swift Dzire Taxi Service Mumbai, Swift Dzire Hire Mumbai, Swift Dzire with Driver Mumbai, Mumbai Sedan Car Rental, Swift Dzire Outstation Cab Mumbai, Swift Dzire Airport Taxi Mumbai, Swift Dzire One Way Cab Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Swiftdzireonrentinmumbai;